// Used for the multi-select dropdown in the enquiry form
export const locationOptions = [
  "3-5 Latona Road",
  "7-17 Latona Road",
  "Action House",
  "Anerley Works",
  "Cannon Wharf",
  "Cobbold Works",
  "Goswell Road",
  "Gransden Avenue",
  "Highbury Studios",
  "Monier Works",
  // "Oxgate House",
  "Paynes Wharf",
  "Platform Studios (East)",
  "Platform Studios (West)",
  "Q West",
  "Standard Road",
  "Stone Studios",
  "The Mille",
  "Unit 10 (Juno Way)",
  "Unit 13 (Elizabeth Tower)",
  "Wallis House",
  "Warwick Works",
];